<mat-card class="configAndArgsContainer">
    <div class="configAndArgsContainer">
        <!--Displaying configuration and arguments table-->
        <div class="config">
            <!-- <app-trigger-artifact [data]="triggerData" [readOnly] ="readOnly" (onSelectArtifact)="getArtifact($event)"></app-trigger-artifact> -->
        </div>
        <!--Displaying Input arguments table-->
        <div class="args">
            <!-- <app-argument-card [wfId]="wfId" [wfhId]="wfhId"  [data]="data"></app-argument-card> -->
        </div>
    </div>

</mat-card>